import { render } from "./RqDocumentsCard.vue?vue&type=template&id=7a35c125&scoped=true"
import script from "./RqDocumentsCard.vue?vue&type=script&lang=js"
export * from "./RqDocumentsCard.vue?vue&type=script&lang=js"

import "./RqDocumentsCard.vue?vue&type=style&index=0&id=7a35c125&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a35c125"]])

export default __exports__